import { FC } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const InPersonIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps(props)}>
    <path
      d="M8.00684 6.16666C8.2829 6.16675 8.50684 6.39057 8.50684 6.66666C8.50684 6.94274 8.2829 7.16657 8.00684 7.16666H8C7.72386 7.16666 7.5 6.9428 7.5 6.66666C7.5 6.39051 7.72386 6.16666 8 6.16666H8.00684Z"
      fill="currentColor"
    />
    <path
      d="M8.00684 8.83334C8.2829 8.83343 8.50684 9.05726 8.50684 9.33334C8.50684 9.60943 8.2829 9.83325 8.00684 9.83334H8C7.72386 9.83334 7.5 9.60949 7.5 9.33334C7.5 9.0572 7.72386 8.83334 8 8.83334H8.00684Z"
      fill="currentColor"
    />
    <path
      d="M8.00684 3.5C8.2829 3.50009 8.50684 3.72391 8.50684 4C8.50684 4.27609 8.2829 4.49991 8.00684 4.5H8C7.72386 4.5 7.5 4.27614 7.5 4C7.5 3.72386 7.72386 3.5 8 3.5H8.00684Z"
      fill="currentColor"
    />
    <path
      d="M10.6735 6.16666C10.9496 6.16675 11.1735 6.39057 11.1735 6.66666C11.1735 6.94274 10.9496 7.16657 10.6735 7.16666H10.6667C10.3905 7.16666 10.1667 6.9428 10.1667 6.66666C10.1667 6.39051 10.3905 6.16666 10.6667 6.16666H10.6735Z"
      fill="currentColor"
    />
    <path
      d="M10.6735 8.83334C10.9496 8.83343 11.1735 9.05726 11.1735 9.33334C11.1735 9.60943 10.9496 9.83325 10.6735 9.83334H10.6667C10.3905 9.83334 10.1667 9.60949 10.1667 9.33334C10.1667 9.0572 10.3905 8.83334 10.6667 8.83334H10.6735Z"
      fill="currentColor"
    />
    <path
      d="M10.6735 3.5C10.9496 3.50009 11.1735 3.72391 11.1735 4C11.1735 4.27609 10.9496 4.49991 10.6735 4.5H10.6667C10.3905 4.5 10.1667 4.27614 10.1667 4C10.1667 3.72386 10.3905 3.5 10.6667 3.5H10.6735Z"
      fill="currentColor"
    />
    <path
      d="M5.34016 6.16666C5.61623 6.16675 5.84016 6.39057 5.84016 6.66666C5.84016 6.94274 5.61623 7.16657 5.34016 7.16666H5.33333C5.05719 7.16666 4.83333 6.9428 4.83333 6.66666C4.83333 6.39051 5.05719 6.16666 5.33333 6.16666H5.34016Z"
      fill="currentColor"
    />
    <path
      d="M5.34016 8.83334C5.61623 8.83343 5.84016 9.05726 5.84016 9.33334C5.84016 9.60943 5.61623 9.83325 5.34016 9.83334H5.33333C5.05719 9.83334 4.83333 9.60949 4.83333 9.33334C4.83333 9.0572 5.05719 8.83334 5.33333 8.83334H5.34016Z"
      fill="currentColor"
    />
    <path
      d="M5.34016 3.5C5.61623 3.50009 5.84016 3.72391 5.84016 4C5.84016 4.27609 5.61623 4.49991 5.34016 4.5H5.33333C5.05719 4.5 4.83333 4.27614 4.83333 4C4.83333 3.72386 5.05719 3.5 5.33333 3.5H5.34016Z"
      fill="currentColor"
    />
    <path
      d="M9.5 14.667V12.667C9.5 12.6228 9.48243 12.5801 9.45117 12.5488C9.41992 12.5176 9.37721 12.5 9.33301 12.5H6.66699C6.62279 12.5 6.58008 12.5176 6.54883 12.5488C6.51757 12.5801 6.5 12.6228 6.5 12.667V14.667C6.49982 14.943 6.27603 15.167 6 15.167C5.72397 15.167 5.50018 14.943 5.5 14.667V12.667C5.5 12.3576 5.623 12.0606 5.8418 11.8418C6.06059 11.623 6.35757 11.5 6.66699 11.5H9.33301C9.64243 11.5 9.93941 11.623 10.1582 11.8418C10.377 12.0606 10.5 12.3576 10.5 12.667V14.667C10.4998 14.943 10.276 15.167 10 15.167C9.72397 15.167 9.50018 14.943 9.5 14.667Z"
      fill="currentColor"
    />
    <path
      d="M12.8337 2.66635C12.8335 2.20626 12.4598 1.83334 11.9997 1.83334H3.99968C3.5397 1.83352 3.16685 2.20637 3.16667 2.66635V13.3333C3.16667 13.7935 3.53959 14.1662 3.99968 14.1664H11.9997C12.4599 14.1664 12.8337 13.7936 12.8337 13.3333V2.66635ZM13.8337 13.3333C13.8337 14.3459 13.0122 15.1664 11.9997 15.1664H3.99968C2.98731 15.1662 2.16667 14.3458 2.16667 13.3333V2.66635C2.16685 1.65409 2.98742 0.833519 3.99968 0.833344H11.9997C13.0121 0.833344 13.8335 1.65398 13.8337 2.66635V13.3333Z"
      fill="currentColor"
    />
  </svg>
);
